exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-to-home-category[data-v-f90f6592] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  font-weight: 700;\n  color: #000000;\n  margin-bottom: 20px;\n  margin-left: 10px;\n}\n.back-to-home-category[data-v-f90f6592]:hover {\n    color: #7e7171;\n}\n.back-to-home-category.underline[data-v-f90f6592]:after, .back-to-home-category[data-v-f90f6592]:not(.no-underline):hover:after {\n  background: none;\n}\n", ""]);

// exports
